import { render, staticRenderFns } from "./GestionLideres.vue?vue&type=template&id=185a8030&scoped=true"
import script from "./GestionLideres.vue?vue&type=script&lang=js"
export * from "./GestionLideres.vue?vue&type=script&lang=js"
import style0 from "./GestionLideres.vue?vue&type=style&index=0&id=185a8030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a8030",
  null
  
)

export default component.exports